import {$moment} from "../funcs";

/**
 * Извлекает время из строки даты+время
 * @param value - строка с датой и временем (может быть в ISO формате или отформатированная строка)
 * @returns время в формате HH:mm или пустая строка
 */
export function extractTimeFromValue(value: string): string {
    if (!value) return '';
    
    // Ищем время в формате HH:mm после пробела (отформатированная строка)
    if (value.includes(' ')) {
        const timePart = value.split(' ').pop();
        if (timePart && /^\d{2}:\d{2}$/.test(timePart)) {
            return timePart;
        }
    }
    
    // Ищем время в ISO формате (T)
    if (value.includes('T')) {
        const timePart = value.split('T')[1]?.slice(0, 5);
        if (timePart && /^\d{2}:\d{2}$/.test(timePart)) {
            return timePart;
        }
    }
    
    // Дополнительная проверка для ISO формата с миллисекундами
    if (value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
        const timePart = value.split('T')[1]?.slice(0, 5);
        if (timePart && /^\d{2}:\d{2}$/.test(timePart)) {
            return timePart;
        }
    }
    
    return '';
}

/**
 * Создает отформатированную дату для отображения из raw_value
 * @param rawValue - raw_value в ISO формате (2025-09-09T12:45:00.000Z) или старом формате DD.MM.YYYY
 * @param includeTime - нужно ли включать время в отображение
 * @returns отформатированная строка для отображения
 */
export function formatDisplayDate(rawValue: string, includeTime: boolean = false): string {
    if (!rawValue) return '';
    
    let dateObj = null;
    let timePart = "";
    
    // Проверяем формат: ISO или старый формат
    if (rawValue.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/)) {
        // ISO формат с временем без UTC (YYYY-MM-DDTHH:mm:ss)
        dateObj = $moment(rawValue, 'YYYY-MM-DDTHH:mm:ss');
        timePart = rawValue.split('T')[1]?.slice(0, 5); // Берем только HH:mm
    } else if (rawValue.match(/^\d{4}-\d{2}-\d{2}T/)) {
        // ISO формат с временем и UTC (YYYY-MM-DDTHH:mm:ss.000Z)
        dateObj = $moment(rawValue);
        timePart = rawValue.split('T')[1]?.slice(0, 5); // Берем только HH:mm
    } else if (rawValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // ISO формат без времени
        dateObj = $moment(rawValue);
    } else if (rawValue.includes('T')) {
        // Старый формат DD.MM.YYYYTHH:mm
        dateObj = $moment(rawValue, 'DD.MM.YYYYTHH:mm');
        timePart = rawValue.split('T')[1];
    } else {
        // Старый формат DD.MM.YYYY
        dateObj = $moment(rawValue, 'DD.MM.YYYY');
    }
    
    if (dateObj && dateObj.isValid()) {
        if (includeTime && timePart) {
            // Если нужно время и оно есть, возвращаем дату + время
            return `${dateObj.format('LL')} ${timePart}`;
        } else {
            // Если времени не нужно или его нет, возвращаем только дату
            return dateObj.format('LL');
        }
    }
    
    return rawValue;
}
